import React from "react";
import "../css/Login.css";
import LoginHook from "../hooks/LoginHook";
import loginImg from "../assets/images/logo-22.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Login = () => {
  let {
    showPassword,
    togglePasswordVisibility,
    formData,
    loading,
    handleLogin,
    handleInputChange,
  } = LoginHook();

  return (
    <>
      <section className="login">
        <div className="row align-items-center justify-content-center w-100 m-0">
          <div className="col-md-6 d-none d-md-block p-0 ">
            <div className="loginImageContainer">
              <img
                src={loginImg}
                className="loginImg"
                alt="loginImg"
                style={{ width: "50%" }}
              />
            </div>{" "}
          </div>
          <form className="col-12 col-md-6 mb-5" onSubmit={handleLogin}>
            <div className="text-center loginText">
              <h4>Welcome to عالم التقسيط</h4>
            </div>
            <div className="coolinput mx-auto" style={{ position: "relative" }}>
              <label htmlFor="admin-email" className="text">
                Email Address:
              </label>
              <input
                id="admin-email"
                type="email"
                onChange={handleInputChange}
                placeholder="Write here..."
                value={formData.email}
                required
                name="email"
                className="input"
              />
              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "60%",
                  transform: "translateY(-50%)",
                }}
              >
                <FontAwesomeIcon icon={faAt} />
              </span>
            </div>
            <div className="coolinput mx-auto" style={{ position: "relative" }}>
              <label htmlFor="admin-password" className="text">
                Password:
              </label>
              <input
                id="admin-password"
                type={showPassword ? "text" : "password"}
                onChange={handleInputChange}
                value={formData.password}
                required
                placeholder="• • • • • •"
                name="password"
                className="input"
              />
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "63%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>
            <div className="login-options mt-3">
              <label className="remember-me-control" htmlFor="remember-me">
                <input
                  id="remember-me"
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  disabled={loading}
                  onChange={handleInputChange}
                />
                <span>Remember me</span>
              </label>
              <Link to="/forgetPassword" className="text-decoration-none">
                Forgot your password?
              </Link>
            </div>
            <div className="forgetPassword mt-3">
              <button
                type="submit"
                disabled={loading}
                className="btn w-100 loginbtn btn-dark"
              >
                {loading ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "LOGIN"
                )}{" "}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default Login;
